<template>
  <div class="page-header-index-wide2">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <div class="wide-box" style="background: #02bebf">
          <div class="top-row">
            <dl class="total-num">
              <dt class="tit">注册总数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
            <dl class="today-num">
              <dt class="tit">今日数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
          </div>
          <dl class="bom-row">
            <dt class="iconfont icon-zjzc"></dt>
            <dd>招标人注册</dd>
          </dl>
        </div>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <div class="wide-box" style="background: #71b603">
          <div class="top-row">
            <dl class="total-num">
              <dt class="tit">注册总数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
            <dl class="today-num">
              <dt class="tit">今日数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
          </div>
          <dl class="bom-row">
            <dt class="iconfont icon-zjzc2"></dt>
            <dd>评标专家注册</dd>
          </dl>
        </div>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <div class="wide-box" style="background: #1890ff">
          <div class="top-row">
            <dl class="total-num">
              <dt class="tit">注册总数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
            <dl class="today-num">
              <dt class="tit">今日数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
          </div>
          <dl class="bom-row">
            <dt class="iconfont icon-zjzc3"></dt>
            <dd>工程投标人注册</dd>
          </dl>
        </div>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <div class="wide-box" style="background: #848e2b">
          <div class="top-row">
            <dl class="total-num">
              <dt class="tit">注册总数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
            <dl class="today-num">
              <dt class="tit">今日数量</dt>
              <dd class="cn">
                <ul>
                  <li>1</li>
                  <li>3</li>
                  <li>5</li>
                </ul>
              </dd>
            </dl>
          </div>
          <dl class="bom-row">
            <dt class="iconfont icon-zjzc4"></dt>
            <dd>采购供应商注册</dd>
          </dl>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="12">
        <a-card :bordered="false" title="专家学历比例图">
          <a-row :gutter="24">
            <a-col :span="12">
              <pie :data="dataSource" :color="['#02bebf', '#71b603', '#1890ff']"></pie>
            </a-col>
            <a-col :span="12">
              <a-table :columns="columns" :data-source="data" :pagination="false" bordered>
                <template slot="name" slot-scope="text">
                  <a>{{ text }}</a>
                </template>
                <template slot="footer">
                  <div style="text-align: right">
                    <a href="#">更多>></a>
                  </div>
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card :bordered="false" title="专家学历比例图">
          <a-row :gutter="24">
            <a-col :span="12">
              <pie :data="dataSource"></pie>
            </a-col>
            <a-col :span="12">
              <a-table :columns="columns" :data-source="data" :pagination="false" bordered>
                <template slot="name" slot-scope="text">
                  <a>{{ text }}</a>
                </template>
                <template slot="footer">
                  <div style="text-align: right">
                    <a href="#">更多>></a>
                  </div>
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="12">
        <a-card :bordered="false" title="企业类型统计" :style="{ marginTop: '24px' }">
          <a-row :gutter="24">
            <a-col :span="24">
              <bar title="销售额排行" :dataSource="barData" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card :bordered="false" title="企业类型统计" :style="{ marginTop: '24px' }">
          <a-row :gutter="24">
            <a-col :span="24">
              <bar title="销售额排行" :dataSource="barData" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Pie from '@/components/chart/cusChart/Pie'
import Bar from '@/components/chart/cusChart/Bar'
const columns = [
  {
    title: '编号',
    dataIndex: 'key',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '专业',
    className: 'column-money',
    dataIndex: 'money'
  },
  {
    title: '占比',
    dataIndex: 'address'
  }
]

const data = [
  {
    key: '1',
    money: '土木工程',
    address: '335'
  },
  {
    key: '2',
    money: '计算机',
    address: '310'
  },
  {
    key: '3',
    money: '电磁维修',
    address: '234'
  }
]
export default {
  components: {
    Pie,
    Bar
  },
  data() {
    return {
      data,
      columns,
      dataSource: [
        { value: 335, name: '土木工程' },
        { value: 310, name: '计算机' },
        { value: 234, name: '电子商务' }
      ],
      barData: []
    }
  }
}
</script>

<style lang="less">
page-header-index-wide2 {
  .ant-card {
    margin-top: 0;
  }
}
.wide-box {
  padding: 10px;
  background-color: #02bebf;
  color: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  .top-row {
    height: 130px;
    display: flex;
    justify-content: space-between;
    .total-num,
    .today-num {
      flex: 1;
      .tit {
        height: 36px;
        font-size: 18px;
      }
      .cn {
        margin-top: 7px;
        ul {
          margin: 0;
          padding: 0;
        }
        li {
          width: 25px;
          height: 25px;
          line-height: 22px;
          text-align: center;
          margin-right: 8px;
          display: inline-block;
          border: 1px solid #d8d8d8;
          border-radius: 3px;
          background-color: #fff;
          color: #333;
        }
      }
    }
    .today-num {
      width: 100px;
    }
  }
  .bom-row {
    border-top: 1px solid rgba(206, 206, 206, 0.4);
    display: flex;
    align-items: center;
    padding: 0 5px;
    dt {
      font-size: 56px;
      margin-right: 35px;
    }
    dd {
      font-size: 18px;
    }
  }
}
</style>
